import { useQuery } from "@apollo/client"
import CustomButton from "components/Atoms/CustomButton"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import ModuleHeader from "components/Templates/ModuleHeader"
import dayjs from "dayjs"
import customFormat from "dayjs/plugin/customParseFormat"
import { DC_STOCK_TAKE_CONFIGS } from "graphql/distribution-center/distribution-center.queries.gql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React, { useState } from "react"
import AddStockTakeDialog from "./AddStockTakeDialog"
import useDCStore from "./dc.store"
dayjs.extend(customFormat)

const StockTake = () => {
  const dcId = useDCStore(store => store.state.basicDetails.id)

  const [{ search }, setFilter] = useSearchFilter()
  const [isOpen, setOpen] = useState(false)
  const [item, setItem] = useState(null)
  const { data, loading, refetch } = useQuery(DC_STOCK_TAKE_CONFIGS, {
    variables: {
      filter: { distributionCentreId: dcId },
    },
  })

  const COLUMNS = [
    SerialColumn,
    {
      value: "id",
      Header: "",
      width: 50,
      Cell({ original }) {
        return (
          <CustomButton
            minimal={true}
            icon="edit"
            onClick={() => {
              setItem(original)
              setOpen(true)
            }}
          />
        )
      },
    },

    {
      Header: "Category",
      accessor: "itemCategory",
      Cell({ value }) {
        return `${value}`
      },
    },
    {
      Header: "Frequency",
      accessor: "startDay",
      Cell({ original }) {
        return `${
          original?.startDay === 0 && original?.endDay === 0
            ? "Daily"
            : original?.startDay >= 1 &&
              original?.startDay <= 7 &&
              original?.endDay === 0
            ? "Weekly"
            : original?.startDay >= 1 && original?.endDay <= 15
            ? "1st Fortnight"
            : original?.startDay >= 16 && original?.endDay <= 30
            ? "2nd Fortnight"
            : "Monthly"
        }`
      },
    },
    {
      Header: "Start",
      accessor: "startDay",
      Cell({ original }) {
        return `${
          original?.startDay === 0 && original?.endDay === 0
            ? dayjs(original.startTime, "HH:mm").format("hh:mm a")
            : `${original?.startDay} - ${dayjs(
                original.startTime,

                "HH:mm"
              ).format("hh:mm a")}`
        }`
      },
    },
    {
      Header: "End",
      accessor: "endDay",
      Cell({ original }) {
        return `${
          original?.startDay === 0 && original?.endDay === 0
            ? dayjs(original.endTime, [
                (dayjs as any).ISO_8601,
                "HH:mm",
              ]).format("hh:mm a")
            : original?.startDay >= 1 &&
              original?.startDay <= 7 &&
              original?.endDay === 0
            ? `${original?.startDay} - ${dayjs(
                original.endTime,
                "HH:mm"
              ).format("hh:mm a")}`
            : `${original?.endDay} - ${dayjs(original.endTime, "HH:mm").format(
                "hh:mm a"
              )}`
        }`
      },
    },
  ]

  // if (error) return <Error message={error?.message} />;

  return (
    <>
      <ModuleHeader
        header="Stock-take Timings"
        borderBottom="none"
        query={search ?? ""}
        onQueryChange={search => {
          setFilter(prev => ({
            ...prev,
            search,
            page: 0,
          }))
        }}
        white
        className="p-3"
      >
        <CustomButton
          text="Category"
          icon="plus"
          dark={true}
          onClick={() => {
            setItem(null)
            setOpen(true)
          }}
        />
      </ModuleHeader>
      <AddStockTakeDialog
        key={item?.codename}
        item={item}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        refetch={refetch}
      />
      <CustomReactTable
        loading={loading}
        data={data?.allDcStockTakeConfigs}
        columns={COLUMNS}
      />
    </>
  )
}

export default StockTake
